export default {
      id: "ic_nav_sportoto-usage",
      viewBox: "0 0 35 30",
      url: "/" + "images/icons.3.109.2.svg#ic_nav_sportoto-usage",
      toString: function () {
        return this.url;
      }
    }